import { Avatar } from '@/components/atoms';
import { PlayerInfoDto } from '@/infrastructure/network/dto/';

interface PlayerHeaderProps {
	playerInfo: PlayerInfoDto;
}

export const PlayerHeader = ({ playerInfo }: PlayerHeaderProps) => {
	return (
		<div className="flex flex-col items-start justify-between gap-5 bg-white sm:flex-row sm:gap-0">
			<div className="flex w-fit items-start gap-6">
				<Avatar
					src={playerInfo?.photo?.url}
					width={60}
					height={60}
					alt={`${playerInfo?.photo?.type} - profile picture`}
					fallbackText={`${playerInfo?.firstName[0]}`}
				/>
				<div className="flex flex-col">
					<div className="flex flex-col lg:flex-row lg:items-center lg:gap-6">
						<p className="text-4xl font-bold tracking-[-0.96px] text-darkorange-400 sm:text-5xl sm:leading-[60px]">
							{playerInfo?.firstName} {playerInfo?.lastName}
						</p>
					</div>

					<div className="mt-[13px] flex flex-col gap-4 text-base font-medium leading-6 text-black sm:flex-row">
						<span>
							DUPR (D){playerInfo?.duprDoubles ?? 'NR'}
							(S){playerInfo?.duprSingles ?? 'NR'}
						</span>
						<span className="hidden sm:inline-block">|</span>
						<span>Email: {playerInfo?.email}</span>
						<div className="flex items-center gap-3.5">
							<span>Cell: {playerInfo?.phone}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
